export default "__VITE_ASSET__CNtf$G0U__"